import { useState } from "react";
import { EVENT_TYPES, Place } from "shared/topchef.types";
import { useTranslation } from "react-i18next";


export interface MyAccountLaterConnectionsProps {
  loggedInPlace: Place,
  updateAcount: (place: Place) => void;
}

const MyAccountLaterConnections = (props: MyAccountLaterConnectionsProps) => {
  const { t } = useTranslation();

  interface MyAccountForm {
    maxGuests: number;
    budget: number;
    acceptReward: boolean;
    supportedEventTypes: string[]
  }

  const [formData, setFormData] = useState<MyAccountForm>({
    maxGuests: props.loggedInPlace.maxGuests,
    budget: props.loggedInPlace.budget,
    acceptReward: props.loggedInPlace.acceptReward,
    supportedEventTypes: props.loggedInPlace.supportedEventTypes
  });



  const handleInputEventChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    
    let value: string | boolean = event.target.value;
    if (name === "acceptReward") {
      value = JSON.parse(value.toLowerCase());
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleCheckboxChange = (value: string) => {
    setFormData((prev) => ({
      ...prev,
      supportedEventTypes: prev.supportedEventTypes.includes(value)
        ? prev.supportedEventTypes.filter((item) => item !== value)
        : [...prev.supportedEventTypes, value],
    }));
  };
  
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const placeToUpdate: Place = {
      id: props.loggedInPlace.id,
      name: props.loggedInPlace.name,
      wpId: props.loggedInPlace.wpId,
      firstConnection: false,
      city: props.loggedInPlace.city,
      region: props.loggedInPlace.region,
      maxGuests: Number(formData.maxGuests),
      budget: formData.budget,
      acceptReward: props.loggedInPlace.acceptReward,
      supportedEventTypes: formData.supportedEventTypes,
      locHallPoints: props.loggedInPlace.locHallPoints
    };

   props.updateAcount(placeToUpdate);

  };

  return (
      <div className="page-profil-settings page-profil container p-5 overflow-auto">
          <div id="lead_sidebar" className="d-flex">
            <ul className="nav nav-pills flex-column mb-auto">
              <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">{t('common.addBrief')}</a></li>
            </ul>
          </div>
          <h5 className="mb-3">{t('account.updateProfile')}</h5>

          <form className="card shadow-sm p-4 align-items-center" onSubmit={handleSubmit}>                        
              
              <div id="commission_acceptance" className="mb-4 text-center">
                  {props.loggedInPlace.acceptReward && 
                    <p className="fw-semibold mb-0">{t('account.commissionsAccepted')}</p>
                  }
                  {props.loggedInPlace.acceptReward === false && 
                    <p className="fw-semibold mb-0">{t('account.commissionsRejected')}</p>
                  }
                  <p className="text-muted small">
                    <a href="mailto:linkevents@lochall.com">{t('account.contactTeam')}</a> {t('account.commissionsMoreInfo')}
                  </p>
              </div>
      
              <div id="event_types" className="mb-4">
                  <p className="fw-semibold text-center">{t('account.eventTypesQuestion')} <i>{t('account.multipleSelection')}</i></p>
                  <div id="event_types_list" className="d-flex flex-wrap gap-2">
                    {EVENT_TYPES.map((eventType) => (
                      <div key={eventType.value}>
                        <input type="checkbox" className="btn-check" id={eventType.value} value={eventType.value} autoComplete="off" name="supportedEventTypes" checked={formData.supportedEventTypes.includes(eventType.value)} onChange={() => handleCheckboxChange(eventType.value)}/>
                        <label className="btn btn-outline-primary" htmlFor={eventType.value}>{t(eventType.label)}</label>
                      </div>
                    ))}
                  </div>
              </div>
          
              <div id="budget_container" className="mb-3 col-md-6 text-center justify-content-center">
                  <label htmlFor="budget" className="form-label fw-semibold">{t('account.minBudget')}</label>
                  <input type="number" id="budget" name="budget" className="form-control w-20 m-auto" placeholder={String(t('leadEditor.amountExVat'))} required min="0" value={formData.budget} onChange={handleInputEventChange} />
              </div>

              <div id="invites_container" className="mb-3 col-md-6 text-center justify-content-center">
                  <label htmlFor="maxGuests" className="form-label fw-semibold">{t('account.maxGuests')}</label>
                  <input type="number" id="maxGuests" name="maxGuests" className="form-control w-20 m-auto" placeholder={String(t('account.maxCapacity'))} required min="0" value={formData.maxGuests} onChange={handleInputEventChange} />
              </div>

              <div className="mt-2 text-center btn-list">
                  <button id="save_profil_settings" className="btn btn-primary">{t('common.save')}</button>
              </div>
          </form>
          
      </div>
  );

}

export default MyAccountLaterConnections;
